module.exports = __webpack_public_path__ + "static/img/rank_top.5b74d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rank_top.png
// module id = s/YE
// module chunks = 1